<account-back class="m-b-9 m-b-7-s m-b-7-m m-t--1 block p-l-2"
              [title]="'Address book' | translate"></account-back>

@if (!addresses?.length) {
<p class="s1"
   cy-addressBookEmpty>
    {{ 'You have no address entries in your address book.' | translate }}
</p>
}

@if (addresses?.length) {
<div [grid]="client.sizeId > 1 ? 2 : 1"
     [gridColumnGap]="'20px'"
     [gridRowGap]="'20px'">
    @for (address of addresses; track address) {
    <account-address-item [gridColumn]="1"
                          [address]="address"></account-address-item>
    }
</div>
}

<a class="button m-t-5 w-12-s w-12-m p-r-5 p-l-5"
   [routerLink]="'/account/address'">
    <ng-container *ifSize="'SM'">+ </ng-container>{{ 'Add new address' | translate }}
</a>
